import { useEffect } from 'react'
import { useModule, useModuleCopy } from '../../../../../context/ModuleContext'
import { Form, FormHeader, FormSelect, FormText, TimestampFilterInput } from '../../form'
import { defaultCriteriaTitleFormatter, useCommentsDefault } from './config'

/** @param {import('./ReportCommentsForm.types').ReportFormCommentsProps} props */
export const CommentsForm = ({ config, setConfig, dateFormatter }) => {
  const { from: defaultFrom, to: defaultTo } = useCommentsDefault()

  // Persist the default dates into the config so they are saved even if the inputs are never changed
  useEffect(() => {
    if (config.from && config.to) return
    setConfig((prev) => ({ ...prev, from: prev.from || defaultFrom, to: prev.to || defaultTo }))
  }, [config.from, config.to, defaultFrom, defaultTo, setConfig])

  return (
    <Form>
      <FormHeader>Comments Block</FormHeader>
      <FormText label='Title' inline value={config.title} onChange={(title) => setConfig((prev) => ({ ...prev, title }))} />
      <CriteriaInput
        value={config.section.id}
        onSelect={(criteria) => {
          setConfig((prev) => ({ ...prev, section: criteria, title: defaultCriteriaTitleFormatter(criteria) }))
        }}
      />
      <TimestampFilterInput label='Completed between:' value={{ from: config.from || defaultFrom, to: config.to || defaultTo }} onChange={({ from, to }) => setConfig((prev) => ({ ...prev, from, to }))} />
    </Form>
  )
}

/** @param {import('./ReportCommentsForm.types').CriteriaInputProps} props */
const CriteriaInput = ({ value, onSelect }) => {
  const { criteria: moduleCriteria } = useModule()

  const {
    textCopy: { criteria: criteriaCopy },
    capitalize
  } = useModuleCopy()

  /** @param {import('./ReportCommentsForm.types').CriteriaConfig} criteria */
  const mapModuleCriteriaToCriteriaConfig = ({ id, name, description }) => ({
    id,
    name,
    description
  })

  /** @type {Array<import('./ReportCommentsForm.types').CriteriaConfig>} */
  const criteriaConfigs = moduleCriteria?.map(mapModuleCriteriaToCriteriaConfig) ?? []

  return (
    <FormSelect
      inline
      label={capitalize(criteriaCopy.label)}
      items={criteriaConfigs}
      value={value}
      getItemLabel={(criteria) => defaultCriteriaTitleFormatter(criteria)}
      getItemValue={(criteria) => criteria.id}
      onSelect={(id) => {
        const criteriaConfig = criteriaConfigs.find((s) => s.id === id)
        if (!criteriaConfig) throw new Error('Undefined section selected')
        onSelect(criteriaConfig)
      }}
    />
  )
}
